import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../../components/navigation/PublicHeader';
import HeroSection from './components/HeroSection';
import ProfileCarousel from './components/ProfileCarousel';
import FeaturesSection from './components/FeaturesSection';
import HiddenMarketSection from './components/HiddenMarketSection';
import ProblemSection from './components/ProblemSection';
import CollaborativePhilosophySection from './components/CollaborativePhilosophySection';
import SolutionSection from './components/SolutionSection';
import ComplementaritySection from './components/ComplementaritySection';
import TalentSection from './components/TalentSection';
import EmployerSection from './components/EmployerSection';
import HowItWorksSection from './components/HowItWorksSection';
import AboutSection from './components/AboutSection';
import TrustSection from './components/TrustSection';
import ContactSection from './components/ContactSection';
import LegalSection from './components/LegalSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const MarketingLanding = () => {
  const navigate = useNavigate();

  const handleRequestAccess = () => {
    navigate('/access-request');
  };

  return (
    <>
      <Helmet>
        <title>BlinD - Anonymous Professional Networking for Senior Talent</title>
        <meta 
          name="description" 
          content="Connect with exceptional career opportunities while maintaining complete anonymity. Premium platform for senior professionals with 8+ years experience and direct employers." 
        />
      </Helmet>

      <div className="min-h-screen bg-white">
        <PublicHeader />
        
        <main className="pt-20">
          <HeroSection onRequestAccess={handleRequestAccess} />
          <ProfileCarousel />
          <FeaturesSection />
          <ProblemSection />
          <HiddenMarketSection />
          <CollaborativePhilosophySection />
          <SolutionSection />
          <ComplementaritySection />
          <EmployerSection />
          <TalentSection />
          <HowItWorksSection />
          <AboutSection />
          <TrustSection />
          <ContactSection />
          <LegalSection />
          <CTASection onRequestAccess={handleRequestAccess} />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default MarketingLanding;